export default __webpack_public_path__ + "static/media/IC.b59b93bd.ico";